import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'actions';
import SliderAdapter from 'components/atoms/slider-adapter';

class FilterSlider extends Component {
    onChange(values) {
        const min = this.parseValue(values[0]);
        const max = this.parseValue(values[1]);

        const {mode} = this.props;
        this.props.dispatch(
            Action.set('InnerPointsBoundary', {
                [mode]: {min, max},
            }),
        );
    }

    parseValue(value) {
        return parseFloat(value);
    }

    getValue(field) {
        const {boundary, mode} = this.props;
        return boundary.getInnerBoundary(field, mode);
    }

    render() {
        const {boundary, mode, step = 0.001} = this.props;

        if (!boundary.hasBoundaries()) {
            return null;
        }

        const defaultMinVal = this.getValue('min');
        const defaultMaxVal = this.getValue('max');
        const minVal = boundary.getOuterMin(mode);
        const maxVal = boundary.getOuterMax(mode);

        return (
            <SliderAdapter
                key={`slider-${defaultMinVal}-${defaultMaxVal}`}
                onChange={this.onChange.bind(this)}
                min={minVal}
                max={maxVal}
                defaultValue={[defaultMinVal, defaultMaxVal]}
                thumb={<div className="circle shifted"></div>}
                minDistance={step}
                step={step}
            />
        );
    }
}

function mapStatesToProps(state) {
    const {pointsBoundary} = state;

    return {
        boundary: pointsBoundary,
    };
}

export default connect(mapStatesToProps)(FilterSlider);
